import * as PIXI from "@pixi/assets";
import { symbolData } from "./SymbolData.js";
import { getAssetsPath } from "./utils/pathConfig";

// Use centralized path configuration
const BASE_PATH = getAssetsPath();

// Generate symbol spine animations from symbol data
// Only include symbols that have spine files (spine property is not empty or null)
const symbolSpines = Object.keys(symbolData)
  .filter((key) => {
    const symbol = symbolData[key];
    // Explicitly check for valid spine: must exist, not null, not empty string, and be a string type
    return (
      symbol &&
      symbol.spine !== null &&
      symbol.spine !== undefined &&
      symbol.spine !== "" &&
      typeof symbol.spine === "string"
    );
  })
  .map((key) => {
    const spineName = symbolData[key].spine;
    // Additional validation: ensure spine name is a clean string (no HTML, no special chars that could cause issues)
    if (
      spineName.includes("<") ||
      spineName.includes(">") ||
      spineName.includes("DOCTYPE") ||
      spineName.includes("html") ||
      spineName.includes("window") ||
      spineName.includes("response") ||
      spineName.trim() !== spineName ||
      spineName.length === 0
    ) {
      return null;
    }
    return {
      name: spineName,
      json: `${BASE_PATH}/spines/reel_symbol/${spineName}.json`,
    };
  })
  .filter((spine) => spine !== null) // Remove null entries from invalid spines
  .filter(
    (spine, index, self) =>
      // Remove duplicates (e.g., multiple coin entries)
      index === self.findIndex((s) => s.name === spine.name)
  );

// ============================================================================
// UI ICONS - Secondary UI active (primary UI icons commented out where not shared)
// ============================================================================
export const UI_ICONS = [
  // ============================================================================
  // PRIMARY UI ONLY - NOT USED (Secondary UI is active)
  // ============================================================================
  {
    name: "icon_home",
    url: `${BASE_PATH}/webp/icon_home.webp`,
  },
  // {
  //   name: "icon_home_active",
  //   url: `${BASE_PATH}/webp/icon_home_active.webp`,
  // },
  // {
  //   name: "icon_fullscreen_enable",
  //   url: `${BASE_PATH}/webp/icon_fullscreen_enable.webp`,
  // },
  // {
  //   name: "icon_fullscreen_disable",
  //   url: `${BASE_PATH}/webp/icon_fullscreen_disable.webp`,
  // },
  // {
  //   name: "icon_game_rules",
  //   url: `${BASE_PATH}/webp/icon_game_rules.webp`,
  // },
  // {
  //   name: "icon_game_rules_active",
  //   url: `${BASE_PATH}/webp/icon_game_rules_active.webp`,
  // },
  {
    name: "icon_sound_enable",
    url: `${BASE_PATH}/webp/icon_sound_enable.webp`,
  },
  {
    name: "icon_sound_disable",
    url: `${BASE_PATH}/webp/icon_sound_disable.webp`,
  },
  // {
  //   name: "icon_paytable",
  //   url: `${BASE_PATH}/webp/icon_paytable.webp`,
  // },
  // {
  //   name: "icon_paytable_active",
  //   url: `${BASE_PATH}/webp/icon_paytable_active.webp`,
  // },
  // {
  //   name: "icon_settings",
  //   url: `${BASE_PATH}/webp/icon_settings.webp`,
  // },
  // {
  //   name: "icon_settings_active",
  //   url: `${BASE_PATH}/webp/icon_settings_active.webp`,
  // },
  // {
  //   name: "icon_plus",
  //   url: `${BASE_PATH}/webp/icon_plus.webp`,
  // },
  // {
  //   name: "icon_minus",
  //   url: `${BASE_PATH}/webp/icon_minus.webp`,
  // },
  // {
  //   name: "icon_autoplay_auto",
  //   url: `${BASE_PATH}/webp/icon_autoplay_auto.webp`,
  // },
  // {
  //   name: "icon_autoplay_quick",
  //   url: `${BASE_PATH}/webp/icon_autoplay_quick.webp`,
  // },
  // {
  //   name: "icon_autoplay_turbo",
  //   url: `${BASE_PATH}/webp/icon_autoplay_turbo.webp`,
  // },
  // {
  //   name: "icon_bet",
  //   url: `${BASE_PATH}/webp/icon_bet.webp`,
  // },

  // ============================================================================
  // SHARED - Used by BOTH primary and secondary UI
  // ============================================================================
  {
    name: "icon_menu",
    url: `${BASE_PATH}/webp/icon_menu.webp`,
  },
  // {
  //   name: "icon_menu_active",
  //   url: `${BASE_PATH}/webp/icon_menu_active.webp`,
  // },
  {
    name: "icon_close",
    url: `${BASE_PATH}/webp/icon_close.webp`,
  },
  // {
  //   name: "icon_close_menu",
  //   url: `${BASE_PATH}/webp/icon_close_menu.webp`,
  // },
  {
    name: "icon_infinity",
    url: `${BASE_PATH}/webp/icon_infinity.webp`,
  },
  {
    name: "icon_play",
    url: `${BASE_PATH}/webp/icon_play.webp`,
  },
  // {
  //   name: "icon_play_disabled",
  //   url: `${BASE_PATH}/webp/icon_play_disabled.webp`,
  // },
  // {
  //   name: "icon_stop",
  //   url: `${BASE_PATH}/webp/icon_stop.webp`,
  // },
  // {
  //   name: "icon_stop_disabled",
  //   url: `${BASE_PATH}/webp/icon_stop_disabled.webp`,
  // },
  {
    name: "icon_turbo",
    url: `${BASE_PATH}/webp/icon_turbo.webp`,
  },
  {
    name: "icon_turbo_active",
    url: `${BASE_PATH}/webp/icon_turbo_active.webp`,
  },
  {
    name: "icon_autoplay",
    url: `${BASE_PATH}/webp/icon_autoplay.webp`,
  },
  {
    name: "icon_popi_max_bet_portrait",
    url: `${BASE_PATH}/webp/icon_popi_max_bet_portrait.webp`,
  },
  {
    name: "icon_popi_max_bet_landscape",
    url: `${BASE_PATH}/webp/icon_popi_max_bet_landscape.webp`,
  },
  {
    name: "icon_bet_select",
    url: `${BASE_PATH}/webp/icon_bet_select.webp`,
  },

  {
    name: "icon_chevron_left",
    url: `${BASE_PATH}/webp/icon_chevron_left.webp`,
  },
  {
    name: "icon_chevron_right",
    url: `${BASE_PATH}/webp/icon_chevron_right.webp`,
  },

  // ============================================================================
  // SECONDARY UI (POPIPLAY) - Currently in use
  // ============================================================================
  {
    name: "icon_popi_game_rules",
    url: `${BASE_PATH}/webp/icon_popi_game_rules.webp`,
  },
  {
    name: "icon_popi_settings",
    url: `${BASE_PATH}/webp/icon_popi_settings.webp`,
  },
  {
    name: "icon_popi_paytable",
    url: `${BASE_PATH}/webp/icon_popi_paytable.webp`,
  },
  {
    name: "icon_popi_plus",
    url: `${BASE_PATH}/webp/icon_popi_plus.webp`,
  },
  {
    name: "icon_popi_minus",
    url: `${BASE_PATH}/webp/icon_popi_minus.webp`,
  },
  {
    name: "icon_popi_bonus_buy",
    url: `${BASE_PATH}/webp/icon_popi_bonus_buy.webp`,
  },
  {
    name: "icon_autoplay_active",
    url: `${BASE_PATH}/webp/icon_autoplay_active.webp`,
  },
  {
    name: "icon_autoplay_background",
    url: `${BASE_PATH}/webp/icon_autoplay_background.webp`,
  },
  {
    name: "popi_triangle",
    url: `${BASE_PATH}/webp/popi_triangle.webp`,
  },
];

// ============================================================================
// UI TEXTURES - Secondary UI active (primary UI textures commented out where not shared)
// ============================================================================
const UI_TEXTURES = [
  // ============================================================================
  // PRIMARY UI ONLY - NOT USED (Secondary UI is active)
  // ============================================================================
  // {
  //   name: "popup_frame_horizontal",
  //   url: `${BASE_PATH}/images/popup_frame_horizontal.webp`,
  // },
  // {
  //   name: "popup_frame_vertical",
  //   url: `${BASE_PATH}/images/popup_frame_vertical.webp`,
  // },
  // {
  //   name: "button_yes",
  //   url: `${BASE_PATH}/images/button_yes.webp`,
  // },
  // {
  //   name: "button_no",
  //   url: `${BASE_PATH}/images/button_no.webp`,
  // },
  // {
  //   name: "popup_button",
  //   url: `${BASE_PATH}/images/popup_button.webp`,
  // },
  // {
  //   name: "popup_button_active",
  //   url: `${BASE_PATH}/images/popup_button_active.webp`,
  // },
  // {
  //   name: "button_switch",
  //   url: `${BASE_PATH}/images/button_switch.webp`,
  // },
  // {
  //   name: "popup_radio_button",
  //   url: `${BASE_PATH}/images/popup_radio_button.webp`,
  // },

  // ============================================================================
  // SHARED - Used by game features and both UIs
  // ============================================================================
  {
    name: "info_frame",
    url: `${BASE_PATH}/images/info_frame.webp`,
  },
  {
    name: "popup_radio_button_active",
    url: `${BASE_PATH}/images/popup_radio_button_active.webp`,
  },
  {
    name: "toolbar_gradient",
    url: `${BASE_PATH}/images/toolbar_gradient.webp`,
  },
  {
    name: "popup_frame_bonus",
    url: `${BASE_PATH}/images/popup_frame_bonus.webp`,
  },
  {
    name: "button_buy_bonus_background",
    url: `${BASE_PATH}/images/button_buy_bonus_background.webp`,
  },

  // ============================================================================
  // SECONDARY UI (POPIPLAY) - Currently in use
  // ============================================================================
  {
    name: "popi_popup_frame_vertical",
    url: `${BASE_PATH}/images/popi_popup_frame_vertical.webp`,
  },
  {
    name: "popi_popup_frame_horizontal",
    url: `${BASE_PATH}/images/popi_popup_frame_horizontal.webp`,
  },
  {
    name: "popi_popup_frame_settings",
    url: `${BASE_PATH}/images/popi_popup_frame_settings.webp`,
  },
  {
    name: "popi_checkbox_background",
    url: `${BASE_PATH}/webp/popi_checkbox_background.webp`,
  },
  {
    name: "popi_checkbox_background_active",
    url: `${BASE_PATH}/webp/popi_checkbox_background_active.webp`,
  },
  {
    name: "popi_checkmark",
    url: `${BASE_PATH}/webp/popi_checkmark.webp`,
  },
  {
    name: "icon_popi_close_button",
    url: `${BASE_PATH}/webp/icon_popi_close_button.webp`,
  },
  {
    name: "popi_volume_bar_background",
    url: `${BASE_PATH}/webp/popi_volume_bar_background.webp`,
  },
  {
    name: "popi_volume_bar_foreground",
    url: `${BASE_PATH}/webp/popi_volume_bar_foreground.webp`,
  },
  {
    name: "popi_volume_bar_button",
    url: `${BASE_PATH}/webp/popi_volume_bar_button.webp`,
  },
  {
    name: "popi_button_bet_background",
    url: `${BASE_PATH}/images/popi_button_bet_background.webp`,
  },
];

// ============================================================================
// GAME TEXTURES - Background, logos, symbols, and game-specific assets
// ============================================================================
const GAME_TEXTURES = [
  {
    name: "background_image",
    url: `${BASE_PATH}/images/background_image.webp`,
  },
  {
    name: "background_image_feature",
    url: `${BASE_PATH}/images/background_image_feature.webp`,
  },
  {
    name: "company_logo",
    url: `${BASE_PATH}/images/company_logo.webp`,
  },
  {
    name: "popi_company_logo",
    url: `${BASE_PATH}/images/popi_company_logo.webp`,
  },
  {
    name: "logo_landscape",
    url: `${BASE_PATH}/images/logo_portrait.webp`,
  },
  {
    name: "logo_portrait",
    url: `${BASE_PATH}/images/logo_portrait.webp`,
  },
  {
    name: "special_symbol_1",
    url: `${BASE_PATH}/images/special_symbol_1.webp`,
  },
  {
    name: "special_symbol_2",
    url: `${BASE_PATH}/images/special_symbol_2.webp`,
  },
  // {
  //   name: "lines_eng",
  //   url: `${BASE_PATH}/images/lines_eng.webp`,
  // },
  // {
  //   name: "lines_srb",
  //   url: `${BASE_PATH}/images/lines_srb.webp`,
  // },
  // Paylines - Portrait
  {
    name: "paylines_01_portrait",
    url: `${BASE_PATH}/images/paylines_01_portrait.webp`,
  },
  {
    name: "paylines_02_portrait",
    url: `${BASE_PATH}/images/paylines_02_portrait.webp`,
  },
  // Paylines - Landscape
  {
    name: "paylines_01_landscape",
    url: `${BASE_PATH}/images/paylines_01_landscape.webp`,
  },
  {
    name: "paylines_02_landscape",
    url: `${BASE_PATH}/images/paylines_02_landscape.webp`,
  },
  {
    name: "reel_symbols",
    url: `${BASE_PATH}/reel_symbols/reel_symbols.json`,
  },
  {
    name: "reel_symbols_blurred",
    url: `${BASE_PATH}/reel_symbols_blurred/reel_symbols_blurred.json`,
  },
  {
    name: "reel_frame_back_static",
    url: `${BASE_PATH}/images/reel_frame_back_static.webp`,
  },
  {
    name: "reel_frame_back_static_feature",
    url: `${BASE_PATH}/images/reel_frame_back_static_feature.webp`,
  },
  {
    name: "reel_frame_front_static",
    url: `${BASE_PATH}/images/reel_frame_front_static.webp`,
  },
  {
    name: "buy_bonus_feature",
    url: `${BASE_PATH}/images/buy_bonus_feature.webp`,
  },
  // Feature Graphics for Paytable
  {
    name: "feature_01_graphics",
    url: `${BASE_PATH}/images/feature_01_graphics.webp`,
  },
  {
    name: "feature_02_graphics",
    url: `${BASE_PATH}/images/feature_02_graphics.webp`,
  },
  {
    name: "feature_03_graphics",
    url: `${BASE_PATH}/images/feature_03_graphics.webp`,
  },
  {
    name: "shine",
    url: `${BASE_PATH}/images/shine.webp`,
  },
];

// ============================================================================
// SPINE ANIMATIONS - Animated spine assets
// ============================================================================
const SPINE_ANIMATIONS = [
  {
    name: "background_animation",
    json: `${BASE_PATH}/spines/background_animation/background_animation.json`,
  },
  {
    name: "win_celebration",
    json: `${BASE_PATH}/spines/win_celebration/win_celebration.json`,
  },
  {
    name: "intro_screen",
    json: `${BASE_PATH}/spines/intro_screen/intro_screen.json`,
  },
  {
    name: "tension",
    json: `${BASE_PATH}/spines/tension/tension.json`,
  },

  {
    name: "wild_expand",
    json: `${BASE_PATH}/spines/wild_expand/wild_expand.json`,
  },
  {
    name: "transition_eye",
    json: `${BASE_PATH}/spines/transition/transition_eye.json`,
  },
  {
    name: "hns_counter",
    json: `${BASE_PATH}/spines/hns_counter/hns_counter.json`,
  },
  {
    name: "hns_multiplier",
    json: `${BASE_PATH}/spines/hns_multiplier/hns_multiplier.json`,
  },
  {
    name: "hns_collector",
    json: `${BASE_PATH}/spines/hns_collector/hns_collector.json`,
  },
  {
    name: "hns_coin_collect",
    json: `${BASE_PATH}/spines/hns_coin_collect/hns_coin_collect.json`,
  },
  {
    name: "hns_end",
    json: `${BASE_PATH}/spines/hns_end/hns_end.json`,
  },
  {
    name: "hns_progress",
    json: `${BASE_PATH}/spines/hns_progress/hns_progress.json`,
  },
  {
    name: "hns_progress_multiplier",
    json: `${BASE_PATH}/spines/hns_progress_multiplier/hns_progress_multiplier.json`,
  },
  {
    name: "hns_progress_tension",
    json: `${BASE_PATH}/spines/hns_progress_tension/hns_progress_tension.json`,
  },
  {
    name: "hns_intro",
    json: `${BASE_PATH}/spines/hns_intro/hns_intro.json`,
  },
  {
    name: "hns_reload",
    json: `${BASE_PATH}/spines/hns_reload/hns_reload.json`,
  },
  {
    name: "max_win",
    json: `${BASE_PATH}/spines/max_win/max_win.json`,
  },
  {
    name: "reel_frame",
    json: `${BASE_PATH}/spines/reel_frame/reel_frame.json`,
  },
  {
    name: "win_lines",
    json: `${BASE_PATH}/spines/win_lines/win_lines.json`,
  },
  {
    name: "winline_digit",
    json: `${BASE_PATH}/spines/winline_digit/winline_digit.json`,
  },
  {
    name: "total_win",
    json: `${BASE_PATH}/spines/total_win/total_win.json`,
  },

  ...symbolSpines,
];

// ============================================================================
// BITMAP FONTS - Font assets
// ============================================================================
const BITMAP_FONTS = [
  {
    name: "font",
    json: `${BASE_PATH}/fonts/font/font.fnt`,
  },
  {
    name: "font_blurred",
    json: `${BASE_PATH}/fonts/font/font_blurred.fnt`,
  },
];

// ============================================================================
// MAIN ASSETS OBJECT - Combines all asset categories
// ============================================================================
export const ASSETS = {
  bitmapFonts: BITMAP_FONTS,
  spineAnimations: SPINE_ANIMATIONS,
  textures: [...UI_ICONS, ...UI_TEXTURES, ...GAME_TEXTURES],
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

/**
 * Generates a flat object mapping asset names to their URLs/JSON paths
 * @param {Object} assets - Assets object with textures, spineAnimations, and bitmapFonts
 * @returns {Object} Flat object with asset names as keys and URLs/JSON paths as values
 */
const generateAssetNames = (assets) => {
  const assetNames = {};

  // Add textures
  assets.textures.forEach((asset) => {
    assetNames[asset.name] = asset.url;
  });

  // Add spine animations
  assets.spineAnimations.forEach((asset) => {
    assetNames[asset.name] = asset.json;
  });

  // Add bitmap fonts
  assets.bitmapFonts.forEach((asset) => {
    assetNames[asset.name] = asset.json;
  });

  return assetNames;
};

/**
 * Gets an asset from PIXI Assets cache if loading succeeded
 * @param {string} status - Loading status
 * @param {string} assetName - Name of the asset to retrieve
 * @returns {*} The asset if succeeded, null otherwise
 */
export const getAsset = (status, assetName) =>
  status === "succeeded" ? PIXI.Assets.get(assetName) : null;

// Generate the asset name mapping
export const ASSET_NAME = generateAssetNames(ASSETS);
